export const dataTimezones = ['America/Sao_Paulo'];
